export const ROUTES = {
  ROOT: '/',
  ERROR: '/error',
  ASSOCIATE: '/associate',
  WATCH: '/watch',
  SERVICES: '/services',
  SERVICE_CERTIFICATION: '/services/certification',
  ACCESSIBILITY_STATEMENT: '/accessibility-statement',
};
